import { FullGridWidthDiv } from '@dreamstack/feature-components/src/layout/MainGrid'
import type { BlockRibbon } from '@dreamstack/payload/src/payload-types'
import { cn } from '@dreamstack/util/src/cn'
import React from 'react'
import { FramerTranlateLeftAnimation } from './FramerTranlateLeftAnimation'
import { TextRibbonContainer } from './TextRibbonContainer'

const PageWidthContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn('flex relative overflow-x-hidden', className)} {...rest}>
    {children}
  </div>
)

interface TextRibbonProps {
  block: BlockRibbon
}

export const TextRibbon: React.FC<TextRibbonProps> = ({ block }) => {
  return (
    <FullGridWidthDiv>
      <PageWidthContainer>
        <FramerTranlateLeftAnimation>
          <TextRibbonContainer block={block} />
        </FramerTranlateLeftAnimation>

        <FramerTranlateLeftAnimation>
          <TextRibbonContainer block={block} />
        </FramerTranlateLeftAnimation>
      </PageWidthContainer>
    </FullGridWidthDiv>
  )
}
